import memoize from 'lodash.memoize';
import gql from 'graphql-tag';
import createClient from '../../../clientSetup';

export const ALLOCATION_QUERY = gql`
  query BYOPAllocation($tickers: [String!]!) {
    mutualFunds(tickers: $tickers) {
      ticker
      trpCode
      minimumInvestmentAmount
      accountMinimumOpenIRA
      openToNewInvestors
      openToSubsequentInvestments
      selectFund
      iClass
      retirementIncome
      retirement
      targetYear
      recordKeepingCode
      grossExpenseRatio
      correspondingFund {
        ticker
        trpCode
        minimumInvestmentAmount
        accountMinimumOpenIRA
        openToNewInvestors
        openToSubsequentInvestments
        selectFund
        iClass
        recordKeepingCode
        grossExpenseRatio
        assetAllocationGroupedRankings {
          rank
          name
          percentTotalNetAssets
          asOfDate
        }
        name: shortName
      }
      assetAllocationGroupedRankings {
        rank
        name
        percentTotalNetAssets
        asOfDate
      }
      name: shortName
    }
  }
`;

export const getFundAllocationsService = memoize(
  async ({ tickers }) => {
    const client = createClient();

    const {
      data: { mutualFunds }
    } = await client.query({
      query: ALLOCATION_QUERY,
      variables: {
        tickers
      }
    });
    return mutualFunds;
  },
  args =>
    Object.keys(args)
      .map(key => args[key])
      .join('.')
);

const assetAllocationMocks = [
  {
    name: 'Africa & Middle East Fund',
    ticker: 'PRISX',
    minimumInvestmentAmount: 2000,
    accountMinimumOpenIRA: 2000,
    assetAllocationGroupedRankings: [
      {
        rank: 0,
        name: 'Foreign Bonds',
        percentTotalNetAssets: 25,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Preferred Stock',
        percentTotalNetAssets: 0,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Convertibles',
        percentTotalNetAssets: 50,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Cash',
        percentTotalNetAssets: -0.2,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      }
    ],
    __typename: 'GraphQLMutualFund'
  },
  {
    name: 'Africa & Middle East Fund',
    ticker: 'TRAMX',
    minimumInvestmentAmount: 2000,
    accountMinimumOpenIRA: 2000,
    assetAllocationGroupedRankings: [
      {
        rank: 0,
        name: 'Foreign Bonds',
        percentTotalNetAssets: 25,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Preferred Stock',
        percentTotalNetAssets: 0,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Convertibles',
        percentTotalNetAssets: 50,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Cash',
        percentTotalNetAssets: -0.2,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      }
    ],
    __typename: 'GraphQLMutualFund'
  },
  {
    name: 'Africa & Middle East Fund',
    ticker: 'TRBCX',
    minimumInvestmentAmount: 2000,
    accountMinimumOpenIRA: 2000,
    assetAllocationGroupedRankings: [
      {
        rank: 0,
        name: 'Foreign Bonds',
        percentTotalNetAssets: 15,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Preferred Stock',
        percentTotalNetAssets: 50,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Convertibles',
        percentTotalNetAssets: 25,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Cash',
        percentTotalNetAssets: 10,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      }
    ],
    __typename: 'GraphQLMutualFund'
  },
  {
    name: 'Africa & Middle East Fund',
    ticker: 'TFAIX',
    minimumInvestmentAmount: 2000,
    accountMinimumOpenIRA: 2000,
    assetAllocationGroupedRankings: [
      {
        rank: 0,
        name: 'Foreign Bonds',
        percentTotalNetAssets: 10,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Preferred Stock',
        percentTotalNetAssets: 10,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Convertibles',
        percentTotalNetAssets: 50,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Cash',
        percentTotalNetAssets: 30,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      }
    ],
    __typename: 'GraphQLMutualFund'
  },
  {
    name: 'Africa & Middle East Fund',
    ticker: 'PRUIX',
    minimumInvestmentAmount: 2000,
    accountMinimumOpenIRA: 2000,
    assetAllocationGroupedRankings: [
      {
        rank: 0,
        name: 'Foreign Bonds',
        percentTotalNetAssets: 25,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Preferred Stock',
        percentTotalNetAssets: 25,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Convertibles',
        percentTotalNetAssets: 25,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Cash',
        percentTotalNetAssets: 25,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      }
    ],
    __typename: 'GraphQLMutualFund'
  }
];

export const ALLOCATION_MOCK = [
  {
    request: {
      query: ALLOCATION_QUERY
    },
    result: {
      data: {
        mutualFunds: assetAllocationMocks
      }
    }
  }
];
